import { createFileRoute } from '@tanstack/react-router';
import { LoginPage } from '@/features/auth/login-page';

type LoginSearch = { tenant?: string; returnTo?: string };

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    ...(typeof search['tenant'] === 'string' ? { tenant: search['tenant'] } : {}),
    // On ne renvoie que sur un chemin interne : un returnTo absolu serait une redirection ouverte.
    ...(typeof search['returnTo'] === 'string' && search['returnTo'].startsWith('/')
      ? { returnTo: search['returnTo'] }
      : {}),
  }),
  component: LoginRoute,
});

function LoginRoute() {
  const { tenant, returnTo } = Route.useSearch();
  return <LoginPage {...(tenant ? { defaultTenant: tenant } : {})} returnTo={returnTo ?? '/'} />;
}
